var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { MOUNT_POINT_LINUX } from '@lucidlink/sdk';
import { InlineForm, TextInputField, translate } from '@lucidlink/uicore';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { PII_MASK_CLASS } from '#constants';
import { DEPENDENCY_KEYS, useDependency } from '#context';
const LINUX_MOUNT_POINT_ID = 'linux-mount-point';
export const LinuxMountPoint = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { handleToasts } = useDependency(DEPENDENCY_KEYS.UseFilespaceSettingsToasts)({
        filespaceId,
        workspaceId,
        settingName: MOUNT_POINT_LINUX,
    });
    const { formData: { linuxMountPoint: formLinuxMountPoint = '' }, } = useFormRoot();
    const { mutation: { isSuccess, mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: MOUNT_POINT_LINUX,
    }, {
        onSuccess: () => {
            handleToasts();
        },
    });
    const setLinuxMountPoint = useCallback(() => setGlobalSettings([
        { fullName: MOUNT_POINT_LINUX, value: formLinuxMountPoint },
    ]), [formLinuxMountPoint, setGlobalSettings]);
    const { default: defaultValue, isDefault, value } = data;
    const autoGenerated = translate('Auto generated');
    const { mutation: { mutate: unsetGlobalSetting }, } = useDependency(DEPENDENCY_KEYS.UseUnsetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: MOUNT_POINT_LINUX,
    }, {
        onSuccess: () => {
            handleToasts({ isReset: true });
        },
    });
    const unsetLinuxMountPoint = useCallback(() => {
        unsetGlobalSetting([MOUNT_POINT_LINUX]);
    }, [unsetGlobalSetting]);
    const onMountPointReset = useDependency(DEPENDENCY_KEYS.UseOnMountPointReset)();
    const resetMountPoint = useCallback(() => {
        if (onMountPointReset) {
            onMountPointReset({
                defaultMountPoint: defaultValue || autoGenerated,
                mountPoint: MOUNT_POINT_LINUX,
                reset: unsetLinuxMountPoint,
            });
        }
        else {
            unsetLinuxMountPoint();
        }
    }, [autoGenerated, defaultValue, onMountPointReset, unsetLinuxMountPoint]);
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset: resetMountPoint,
            tooltip: translate(`The default value is: {{value}}`, {
                value: defaultValue || autoGenerated,
            }),
        };
    const labelDefault = isDefault ? translate('Default') : undefined;
    const labelTooltip = useMemo(() => [
        translate('Linux only. Specify the path where the filespace will be mounted.'),
        translate('Accepted options:'),
        translate('Valid absolute path (e.g. "/media/workspace/filespace")'),
    ], []);
    return (_jsx(InlineForm, { cancelAriaLabel: translate('cancel'), "data-testid": LINUX_MOUNT_POINT_ID, formElement: (labelProps) => (_jsx(TextInputField, { ...labelProps, autoFocus: true, "data-testid": LINUX_MOUNT_POINT_ID, id: LINUX_MOUNT_POINT_ID, initialValue: value, name: "linuxMountPoint" })), inputId: LINUX_MOUNT_POINT_ID, isSaveAllowed: value !== formLinuxMountPoint, isSuccess: isSuccess, label: translate('Linux mount point'), labelDefault: labelDefault, labelTooltip: labelTooltip, onSave: setLinuxMountPoint, resetToDefault: resetToDefault, saveAriaLabel: translate('Save'), tooltipPosition: "right", value: value || autoGenerated, valueClassName: PII_MASK_CLASS, width: "sm" }));
};
_react_refresh_temp_1 = LinuxMountPoint;
$RefreshReg$(_react_refresh_temp_1, "LinuxMountPoint");
_react_refresh_temp_2(LinuxMountPoint, "eMFFEcuPhZnj1xabUd6cs2lDqqI=", false, () => [useDependency, useFormRoot, useDependency, useDependency, useDependency]);
